import logo from '../images/icon.png';
import React, { useEffect, useState } from 'react';
import {useHistory} from 'react-router-dom';
import '../style/parallax-star.css';
import {IoPerson, IoKey} from "react-icons/io5";

import Login from "../api/Authentication";
import Modal from '../components/Modal';
import { useLanguage } from '../i18n/LanguageContext';

export default function SignIn() {
  const { t } = useLanguage();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [iShow, setiShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  let history = useHistory();

  useEffect(()=>{
    if(localStorage.getItem("accessToken")){
      history.replace("/home");
    }
  }, [history]);

  const doSignIn = async () => {
    setLoading(true);
    const data = await Login(username, password);
    setLoading(false);

    if(data.status === "success"){
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("username", username);
      history.replace("/home");
    }else{
      setModalMessage(data.message);
      setiShow(true);
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      doSignIn();
    }
  }

  return (
    <div className="parallax-back">
      <Modal mState={{iShow, setiShow}}>
          {
            loading ? <p>{t('common.loading')}</p>
            :
            modalMessage
          }
      </Modal>
      <div className="App">
        <div className="App-Auth">
          <header style={{zIndex: 20}}>
            <img src={logo} className="App-logo" alt="logo" />
            <p>Cyclone™</p>
          </header>
            <div className="row inputplace">
              <div className="inputfield">
                <IoPerson/>
                <input type="text" id="UsernameInput" placeholder={t('auth.usernamePlaceholder')} value={username} autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} onChange={(e)=>{setUsername(e.target.value);}}></input>
              </div>

              <div className="inputfield">
                <IoKey/>
                <input type="password" id="PasswordInput" onKeyDown={onKeyDown} placeholder={t('auth.passwordPlaceholder')} value={password} autoComplete="current-password" onChange={(e)=>{setPassword(e.target.value);}}></input>
              </div>

              <div className="inputfield">
                <button onClick={doSignIn} className="primaryColor" style={{marginRight:20}}>{loading ? t('auth.processing') : t('auth.signIn')}</button>
                <button onClick={()=>{history.push({pathname: "/register", state: {username, password}});}} className="secondaryColor">{t('auth.signUp')}</button>
              </div>

              <button onClick={()=>{history.push("/forgot-password");}} className="AuthLink">{t('auth.forgotPassword')}</button>
            </div>
        </div>
      </div>
      <div id='stars'></div>
      <div id='stars2'></div>
      <div id='stars3'></div>
    </div>
  );
}
